export default __webpack_public_path__ + "static/media/denim-blue.263d577c.jpg";